{
  "id": "campaign-119",
  "name": "Weedy Parterre",
  "seed": "campaign:119",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "..,,,,,ACCA,,,,,,,",
    "..,,,,,,CC,,,,,,,,",
    "..,,,t,,CC,,t,,,,,",
    ",,t,t,,tCCt,,t,t,,",
    ",x,,,,,,CC,,,,,,,,",
    ",,,,,,,CCCC,...,,,",
    ",,,,,x,CwwC.....,,",
    ",t**,,,CwwC...**t,",
    ",,**%%,CwwC.%%**,,",
    ",,,,%,,CCCC,.%.,,,",
    ",,,,,,,,CC,,,,,,,,",
    "w+wwwwww++wwwwww+w",
    ",,,,,,,,CC,...,,,,",
    ",,,,,,,,CC.....,,,",
    ",,,Y,,,tCCt...Y,,,",
    "..,,,,,,CC.....,,,",
    "...,,,,,,,,.,,,,,,",
    "S..,,,,,,x,,,,,,,,"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 10,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 13,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 2
    },
    {
      "kind": "rabbit",
      "x": 15,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 12,
      "y": 7
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 16,
      "y": 17
    },
    {
      "kind": "gas",
      "x": 14,
      "y": 0
    },
    {
      "kind": "gas",
      "x": 0,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 13
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 10
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 0,
      "y": 4,
      "w": 5,
      "h": 5
    },
    {
      "x": 13,
      "y": 4,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 119,
  "biome": "estate",
  "par": {
    "reel": 10910,
    "push": 9740,
    "selfPropelled": 8716,
    "tractor": 7444,
    "zeroTurn": 6372,
    "fairway": 4294
  },
  "goldTime": {
    "reel": 10910,
    "push": 9649,
    "selfPropelled": 8716,
    "tractor": 7214,
    "zeroTurn": 6372,
    "fairway": 3953
  },
  "routeTries": {
    "par": {
      "reel": 18,
      "push": 20,
      "selfPropelled": 0,
      "tractor": 12,
      "zeroTurn": 13,
      "fairway": 9
    },
    "gold": {
      "reel": 18,
      "push": 43,
      "selfPropelled": 0,
      "tractor": 33,
      "zeroTurn": 13,
      "fairway": 36
    }
  }
}
